// extracted by mini-css-extract-plugin
module.exports = {"gallery":"cover_gallery__1hNty","galleryItem":"cover_galleryItem__2DDCv","previewOverlay":"cover_previewOverlay__33S_l","previewContent":"cover_previewContent__3nz-Z"};